import React from 'react';
import { AlertTriangle, CheckCircle2, CloudOff, Loader2, Save, RotateCcw } from 'lucide-react';
import { Button } from '@/components/ui/button';

const STYLES = {
  idle: 'bg-slate-50 border-slate-200 text-slate-600',
  dirty: 'bg-amber-50 border-amber-300 text-amber-900',
  saving: 'bg-blue-50 border-blue-300 text-blue-900',
  saved: 'bg-emerald-50 border-emerald-300 text-emerald-900',
  error: 'bg-red-50 border-red-300 text-red-900',
};

function label(state, pending) {
  if (state.kind === 'saving') return 'Enregistrement en cours…';
  if (state.kind === 'error') return `Échec — ${state.message}`;
  if (pending > 0) return `Modifications non enregistrées : ${pending} cellule(s)`;
  if (state.kind === 'saved') return `Enregistré et confirmé par le serveur à ${state.at}${state.message ? ` — ${state.message}` : ''}`;
  return 'Aucune modification en attente';
}

export const PlanningSaveStatus = ({ state, pending, conflicts, refreshing, lastSync, onSave, onDiscard }) => {
  const kind = state.kind === 'saving' || state.kind === 'error' ? state.kind : (pending > 0 ? 'dirty' : state.kind);
  const Icon = kind === 'saving' ? Loader2 : kind === 'error' ? CloudOff : kind === 'saved' ? CheckCircle2 : kind === 'dirty' ? AlertTriangle : CheckCircle2;
  return (
    <div className={`fixed bottom-4 left-1/2 z-50 flex w-[min(96vw,64rem)] -translate-x-1/2 flex-wrap items-center gap-3 rounded-lg border px-4 py-2 text-sm shadow-lg ${STYLES[kind]}`}
      data-testid="planning-save-status" data-state={kind} role="status" aria-live="polite">
      <Icon className={`h-4 w-4 shrink-0 ${kind === 'saving' ? 'animate-spin' : ''}`} />
      <span className="font-medium" data-testid="planning-save-status-text">{label(state, pending)}</span>
      {conflicts > 0 && (
        <span className="rounded bg-red-600 px-2 py-0.5 text-xs font-semibold text-white" data-testid="planning-conflict-count">
          {conflicts} conflit(s) à arbitrer
        </span>
      )}
      <span className="ml-auto text-xs opacity-70" data-testid="planning-last-sync">
        {refreshing ? 'Synchronisation…' : lastSync ? `Synchronisé à ${lastSync}` : ''}
      </span>
      {pending > 0 && (
        <>
          <Button size="sm" variant="outline" onClick={onDiscard} disabled={state.kind === 'saving'} data-testid="planning-discard-btn">
            <RotateCcw className="mr-1 h-3.5 w-3.5" /> Abandonner
          </Button>
          <Button size="sm" onClick={onSave} disabled={state.kind === 'saving'} className="btn-accent" data-testid="planning-save-btn">
            <Save className="mr-1 h-3.5 w-3.5" /> Enregistrer
          </Button>
        </>
      )}
    </div>
  );
};
